import Immutable from 'immutable'
import { API_CUSTOMER_PROFILE } from '../actions/apiCustomerProfile'

const defaultState = Immutable.fromJS({
  status: 'UNINIT'
})

export default (s, action) => {
  const state = s || defaultState
  switch (action.type) {
    case `${API_CUSTOMER_PROFILE}_REQUEST`:
    {
      return state.withMutations((st) => {
        st.set('status', 'PENDING')
        st.set('profile', '')
      })
    }

    case `${API_CUSTOMER_PROFILE}_SUCCESS`:
    {
      return state.withMutations((st) => {
        st.set('status', 'SUCCESS')
        st.set('profile', action.res)
      })
    }

    case `${API_CUSTOMER_PROFILE}_FAILURE`:
    {
      return state.withMutations((st) => {
        st.set('status', 'FAILURE')
        st.set('profile', '')
        st.set('statusCode', action.error.status)
      })
    }

    default:
      return state
  }
}

// Selectors
export const getCustomerProfileSelector = ({ apiCustomerProfile }) => {
  return {
    status: apiCustomerProfile.get('status'),
    statusCode: apiCustomerProfile.get('statusCode'),
    profile: apiCustomerProfile.get('profile')
  }
}
